import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const WorkspaceSettingsOrganizationWorkspaceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"WorkspaceSettingsOrganizationWorkspace"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"organization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orgId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"canEditDomain"}},{"kind":"Field","name":{"kind":"Name","value":"domainName"}},{"kind":"Field","name":{"kind":"Name","value":"domain"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"displayName"}}]}},{"kind":"Field","name":{"kind":"Name","value":"idEnterprise"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"WorkspaceSettingsOrganizationWorkspace","document":WorkspaceSettingsOrganizationWorkspaceDocument}} as const;
export type WorkspaceSettingsOrganizationWorkspaceQueryVariables = Types.Exact<{
  orgId: Types.Scalars['ID'];
}>;


export type WorkspaceSettingsOrganizationWorkspaceQuery = (
  { __typename: 'Query' }
  & { organization?: Types.Maybe<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'id' | 'canEditDomain' | 'domainName' | 'idEnterprise'>
    & { domain?: Types.Maybe<(
      { __typename: 'DomainOrganization' }
      & Pick<Types.DomainOrganization, 'displayName'>
    )> }
  )> }
);

/**
 * __useWorkspaceSettingsOrganizationWorkspaceQuery__
 *
 * To run a query within a React component, call `useWorkspaceSettingsOrganizationWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useWorkspaceSettingsOrganizationWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWorkspaceSettingsOrganizationWorkspaceQuery({
 *   variables: {
 *      orgId: // value for 'orgId'
 *   },
 * });
 */
export function useWorkspaceSettingsOrganizationWorkspaceQuery(
  baseOptions: TrelloQueryHookOptions<
    WorkspaceSettingsOrganizationWorkspaceQuery,
    WorkspaceSettingsOrganizationWorkspaceQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: WorkspaceSettingsOrganizationWorkspaceDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    WorkspaceSettingsOrganizationWorkspaceQuery,
    WorkspaceSettingsOrganizationWorkspaceQueryVariables
  >(WorkspaceSettingsOrganizationWorkspaceDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useWorkspaceSettingsOrganizationWorkspaceLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    WorkspaceSettingsOrganizationWorkspaceQuery,
    WorkspaceSettingsOrganizationWorkspaceQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    WorkspaceSettingsOrganizationWorkspaceQuery,
    WorkspaceSettingsOrganizationWorkspaceQueryVariables
  >(WorkspaceSettingsOrganizationWorkspaceDocument, options);
}
export type WorkspaceSettingsOrganizationWorkspaceQueryHookResult = ReturnType<
  typeof useWorkspaceSettingsOrganizationWorkspaceQuery
>;
export type WorkspaceSettingsOrganizationWorkspaceLazyQueryHookResult = ReturnType<
  typeof useWorkspaceSettingsOrganizationWorkspaceLazyQuery
>;
export type WorkspaceSettingsOrganizationWorkspaceQueryResult = Apollo.QueryResult<
  WorkspaceSettingsOrganizationWorkspaceQuery,
  WorkspaceSettingsOrganizationWorkspaceQueryVariables
>;
